import { render } from "./FormReadCode.vue?vue&type=template&id=1c58286c&bindings={\"webcam\":\"data\",\"webcamIsClose\":\"data\",\"answer\":\"data\",\"reading\":\"data\",\"flipped\":\"data\",\"webcamIsOpen\":\"options\",\"openCamera\":\"options\",\"flipCamera\":\"options\",\"readCode\":\"options\",\"copy\":\"options\",\"_reset\":\"options\",\"_closeCamera\":\"options\"}"
import script from "./FormReadCode.vue?vue&type=script&lang=js"
export * from "./FormReadCode.vue?vue&type=script&lang=js"
script.render = render

export default script